<script setup lang="ts">
import { computed } from 'vue'
import OpensInNewTabIcon from '@/components/OpensInNewTabIcon.vue'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin'
import { EVENT_NAMES } from '@/tracking/analytics/event_names'
import { toolkitUrls } from '@/util/links'
import { keepingBetaOptIn } from '@/util/beta_opt_in'

export interface AlignedGoal {
  uuid: string
  title: string
}

const props = defineProps<{ goal: AlignedGoal }>()

const analytics = getAnalyticsTracker()

const anchorPageUrl = computed(() => keepingBetaOptIn(toolkitUrls.anchorPage(props.goal.uuid)))

function recordOpenedGoalLink() {
  analytics.sendEvent(EVENT_NAMES.RESOURCES.OPENED_ALIGNED_GOAL_LINK, {
    aligned_goal_title: props.goal.title,
    aligned_goal_uuid: props.goal.uuid
  })
}
</script>

<template>
  <p class="pb-1 text-md text-gray-700">
    Aligned to goal:
    <a :href="anchorPageUrl" target="_blank" class="text-blue-400 hover:underline" @click="recordOpenedGoalLink">
      {{ goal.title }}
      <OpensInNewTabIcon />
    </a>
  </p>
</template>
